/** User roles matching group names in DB, see also \Macaw\Shared\Data\Database\Constants\Groups.cs */
export enum UserRole {
    Admins = "Admins",
    Moderators = "Moderators",
    Author = "Author",
    MicrosoftEmployees = "MicrosoftEmployees",
    AuthenticatedUsers = "Users",
    MVP = "MVP",
}

export enum Permission {
    // Ticket
    Ticket_View = "Ticket_View",
    Ticket_Add = "Ticket_Add",
    Ticket_Edit = "Ticket_Edit",
    Ticket_FlagForModeration = "Ticket_FlagForModeration",
    Ticket_Vote = "Ticket_Vote",
    Ticket_FollowOrUnfollow = "Ticket_FollowOrUnfollow",
    Ticket_ViewInternalTicket = "Ticket_ViewInternalTicket",

    // Comment
    Comment_View = "Comment_View",
    Comment_Add = "Comment_Add",
    Comment_Edit = "Comment_Edit",
    Comment_Delete = "Comment_Delete",
    Comment_FlagForModeration = "Comment_FlagForModeration",
    Comment_Vote = "Comment_Vote",
    Comment_Convert = "Comment_Convert",

    // Solution
    Solution_View = "Solution_View",
    Solution_Add = "Solution_Add",
    Solution_Edit = "Solution_Edit",
    Solution_Delete = "Solution_Delete",
    Solution_FlagForModeration = "Solution_FlagForModeration",
    Solution_Convert = "Solution_Convert",
    Solution_Vote = "Solution_Vote",
    Solution_Reactivate = "Solution_Reactivate",

    // Previews
    Preview2 = "Preview2",
}

export interface AccessPolicy {
    permission: Permission;
    requiredRoles: UserRole[];
}
